import dayjs from 'dayjs'
import * as R from 'ramda'
import {
  GetProfile,
  Location,
  Profile,
  reqGetProfile,
  reqUpdateProfile,
  ReqUpdateProfilePayload,
  UpdateProfile,
} from '@weblite/sahab-profile-action/profile'
import { profileStorage } from './storage'
import { request } from '$setup/ws'
import { getClientUserId } from '$logic/client-user'
import { openProfileCompletion } from '$logic/router'
import { dateWithOffset } from '$setup/time-offset'

export function getProfile(): Profile {
  const profile = profileStorage.get()
  if (profile) return profile
  return {
    birthDate: '',
    gender: null,
    location: null,
    updatedAt: null,
    userId: getClientUserId(),
  }
}

export function getReadableLocation(location: Location) {
  return `${location.province}، ${location.county}`
}

export function getReadableBirthDate(birthDate: string) {
  // TODO
  return birthDate
}

function getAgeFromBirthDate(birthDate: string) {
  return dayjs(dateWithOffset()).diff(dayjs(birthDate), 'year')
}

function setProfileGAEvent() {
  if (!window.gtag) return

  const { gender, location, birthDate } = getProfile()

  const age = getAgeFromBirthDate(birthDate)
  const userProperties = {
    ...(gender && { gender }),
    ...location,
    ...(age && { age }),
  }
  if (!R.isEmpty(userProperties)) {
    window.gtag('set', 'user_properties', userProperties)
  }
}

export async function editProfile(profile: ReqUpdateProfilePayload['profile']) {
  const res = await request<UpdateProfile>(reqUpdateProfile({ profile }))
  if (res.error) {
    // TODO handle UI
    throw res.error.message
  }
  await profileStorage.set({ ...profile, ...res.payload })
  setProfileGAEvent()
}

export async function syncProfile(): Promise<void> {
  const res = await request<GetProfile>(reqGetProfile({}))
  await profileStorage.set(res.payload?.profile)
  const tasks = res.payload?.profile.tasks
  if (tasks?.includes('register_SJF2')) {
    openProfileCompletion()
  }
  setProfileGAEvent()
}
